import { immer } from "zustand/middleware/immer";

import { User, UserRole } from "@/types";
import { createStore } from "@/utils";

type UserState = {
  role?: User["role"];
  referrerCode?: User["referrerCode"];
};

type UserActions = {
  actions: {
    setRole: (role: UserRole) => void;
    setReferrerCode: (code: User["referrerCode"]) => void;
  };
};

const defaultUserValues: UserState = {
  referrerCode: "",
};

const useUserStore = createStore<UserState & UserActions>(
  immer((set) => ({
    ...defaultUserValues,
    actions: {
      setRole: (role) =>
        set((state) => {
          state.role = role;
        }),
      setReferrerCode: (code) =>
        set((state) => {
          state.referrerCode = code;
        }),
    },
  }))
);

export { useUserStore };
